import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import { useForm } from 'react-hook-form';
import { useRecoilValue } from 'recoil';
import { authAtom } from '../../_state';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import DatePicker from 'components/Date/DatePicker';
import moment from 'moment';
import 'dayjs/locale/ko';
import { Autocomplete } from '@mui/material';

export default function FreeCouponOrder(props) {
  const auth = useRecoilValue(authAtom);
  const { username, companyName, companyNo } = auth;

  const {
    handleSubmit,
    register,
    clearErrors,
    reset,
    formState: { errors, isDirty, isSubmitting }
  } = useForm({
    defaultValues: {}
  });

  const { open, handleClose, getDataList, handleChangeTab } = props;
  const [couponQuantity, setCouponQuantity] = useState(0);
  const [buyQuantity, setBuyQuantity] = useState(1);
  const [codeDate, setCodeDate] = useState(1);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [companyId, setCompanyId] = useState();
  const [companyList, setCompanyList] = useState([]);

  const handleChange = (e) => {
    setBuyQuantity(e.target.value || 1);
  };

  const handleChangeCodeDate = (e) => {
    setCodeDate(e.target.value || 1);
  };
  const couponOrder = async (data) => {
    let formData = new FormData();
    const config = {
      headers: { 'content-type': 'multipart/form-data' }
    };
    formData.append('companyId', companyId);
    formData.append('quantity', buyQuantity);
    formData.append('codeDate', codeDate);
    formData.append('startDate', startDate);
    formData.append('endDate', endDate);
    return await axios.post(`/api/coupon/freeorder`, formData, config);
  };

  const onSubmit = async (data) => {
    if (!isSubmitting) {
      await couponOrder(data)
        .then((response) => {
          alert(response.data.message);
          handleChangeTab(null, 3);
          getDataList();
          handleClose();
        })
        .catch((error) => {
          alert(error.response.data.message);
        });
    }
  };

  const getCouponQuantity = async () => {
    const response = await axios.get(`/api/coupon/count/${auth.companyId}`);
    setCouponQuantity(response.data.couponQuantity);
  };

  const setCompanyById = async (value) => {
    if (value) {
      setCompanyId(value?.value);
      getCouponQuantity(value?.value);
    }
  };

  useEffect(async () => {
    if (open) {
      await axios.get(`/api/companys`).then((result) => {
        if (result.data) {
          let tempList = [];
          result.data.map((data, rowIdx) => {
            let temp = {};
            temp.label = `${data.companyName}`;
            temp.value = data.id;
            tempList.push(temp);
          });
          setCompanyList(tempList);
        }
      });
      setCouponQuantity(0);
      setBuyQuantity(1);
      setCodeDate(1);
      setStartDate(new Date());
      setEndDate(new Date());
      clearErrors();
      reset();
    }
  }, [open]);

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="draggable-dialog-title">
      <Box component="form" onSubmit={handleSubmit(onSubmit)} noValidate sx={{ mt: 1 }}>
        <DialogTitle id="draggable-dialog-title">무료 사용권 발급</DialogTitle>
        <DialogContent dividers>
          <Box>
            <TableContainer component={'div'}>
              <Table size="small">
                <TableRow>
                  <TableCell>회사</TableCell>
                  <TableCell>
                    <Autocomplete
                      id="companyId"
                      size="small"
                      label="회사"
                      sx={{ width: 300 }}
                      options={companyList}
                      renderInput={(params) => <TextField {...params} label="회사" autoFocus />}
                      error={!!errors.companyId}
                      helperText={errors.companyId && errors.companyId.message}
                      {...register('companyId')}
                      onChange={(event: any, newValue: string | null) => {
                        setCompanyById(newValue);
                      }}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>현재 사용권</TableCell>
                  <TableCell>{couponQuantity || 0}장</TableCell>
                </TableRow>
              </Table>
            </TableContainer>
          </Box>
          <Box>
            <TableContainer component={'div'}>
              <Table size="small">
                <TableRow>
                  <TableCell>발급 수량</TableCell>
                  <TableCell colSpan={2}>
                    <TextField
                      id="count"
                      type="number"
                      variant="outlined"
                      size="small"
                      sx={{ width: 200 }}
                      inputProps={{ defaultValue: 1, min: 1, max: 300, style: { textAlign: 'right' }, pattern: '[0-9]*' }}
                      value={buyQuantity || 1}
                      error={!!errors.quantity}
                      helperText={errors.quantity && errors.quantity.message}
                      {...register('quantity', {
                        required: '사용권 수량을 입력해주세요.'
                      })}
                      onChange={handleChange}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>코드 사용 기간 (일)</TableCell>
                  <TableCell colSpan={2}>
                    <TextField
                      id="count"
                      type="number"
                      variant="outlined"
                      size="small"
                      sx={{ width: 200 }}
                      inputProps={{ defaultValue: 1, min: 1, max: 300, style: { textAlign: 'right' }, pattern: '[0-9]*' }}
                      value={codeDate || 1}
                      error={!!errors.codeDate}
                      helperText={errors.codeDate && errors.codeDate.message}
                      {...register('codeDate', {
                        required: '코드 사용 기간을 입력해주세요.'
                      })}
                      onChange={handleChangeCodeDate}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>사용 시작일</TableCell>
                  <TableCell>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'ko'}>
                      <DatePicker
                        inputFormat={'YYYY-MM-DD'}
                        value={startDate}
                        onChange={(newValue) => {
                          setStartDate(newValue);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            id="startDate"
                            name="startDate"
                            size="small"
                            sx={{ width: '70%' }}
                            error={!!errors.startDate}
                            helperText={errors.startDate && errors.startDate.message}
                            {...register('startDate', {
                              required: '시작일을 입력해주세요.'
                            })}
                          />
                        )}
                        disableMaskedInput={true}
                        disablePast={true}
                        // disableFuture={true}
                        minDate={moment().format('YYYY-MM-DD')}
                        maxDate={moment().add(14, 'days').format('YYYY-MM-DD')}
                      />
                    </LocalizationProvider>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>사용 종료일</TableCell>
                  <TableCell>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'ko'}>
                      <DatePicker
                        inputFormat={'YYYY-MM-DD'}
                        value={endDate}
                        onChange={(newValue) => {
                          setEndDate(newValue);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            id="endDate"
                            name="endDate"
                            size="small"
                            sx={{ width: '70%' }}
                            error={!!errors.endDate}
                            helperText={errors.endDate && errors.endDate.message}
                            {...register('endDate', {
                              required: '종료일을 입력해주세요.'
                            })}
                          />
                        )}
                        disableMaskedInput={true}
                        disablePast={true}
                        // disableFuture={true}
                        minDate={moment().format('YYYY-MM-DD')}
                        maxDate={moment().add(14, 'days').format('YYYY-MM-DD')}
                      />
                    </LocalizationProvider>
                  </TableCell>
                </TableRow>
              </Table>
            </TableContainer>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button type="submit" variant="contained" color="primary">
            발급
          </Button>
          <Button variant="outlined" color="success" onClick={handleClose}>
            닫기
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
